export const LIVE_SHARES = "LIVE_SHARES";
export const LIVE_SHARES_COUNT = "LIVE_SHARES_COUNT";
export const LIVE_SHARES_BUSY = "LIVE_SHARES_BUSY";
